<template>
      <v-layout row wrap justify-center align-center >
          <v-flex xs12>
            <h2>Projeto Padrão - {{ projetoData.name }}</h2>
            <v-expansion-panel class="mt-1">
                <v-expansion-panel-content>
                  <div slot="header"> 
                    Detalhes do projeto padrão {{ projetoData.name }}
                  </div>
                    <v-card class='mb-2'>
                      <v-card-title class="ml-4">
                        <v-flex xs12 md3>
                          <v-avatar tile class="text-xs-center" size="150">
                              <img :src="projetoData.image_medium" @error="imageError()" ref="logo" class="rounded-corner" alt="">
                              <v-btn
                                absolute
                                dark
                                fab
                                bottom
                                right
                                color="blue"
                                small
                                class='image-edit'
                                @click.prevent="imageChangeModal = true"
                                v-if="this.$store.state.selectedRole.name === 'Admin' || 
                                      this.$store.state.selectedRole.name === 'Mediador' || permissao"
                                >
                                <v-icon>mode_edit</v-icon>
                              </v-btn>
                          </v-avatar>
                          <change-image
                            v-if="imageChangeModal"
                            @imageCropped="imageProject"
                            @modalClose="imageChangeModal = false"
                            :isShow="imageChangeModal"
                            >
                          </change-image>
                        </v-flex>
                        <v-flex xs12 md9 justify-start> 
                          <v-icon
                            v-if="editing"
                            size="25"
                            @click="dialogDel = true"
                            style="float: right" 
                          >
                            delete
                          </v-icon>      
                          <v-spacer></v-spacer>
                          <profile-text title="Nome : " v-model='projetoData.name'
                            :editing='editing'></profile-text>
                          <profile-text title="Descrição : " v-model='projetoData.description'
                            :editing='editing'
                            input-type='multilinetext'></profile-text>
                          <profile-text title="Justificativa : " v-model='projetoData.justificativa'
                          :editing='editing'
                          input-type='multilinetext'></profile-text>
                          <profile-text title="Recursos : " v-model='projetoData.recursos'
                          :editing='editing'
                          input-type='multilinetext'></profile-text>
                          <profile-text title="Objetivo : " v-model='projetoData.objetivo'
                          :editing='editing'
                          input-type='multilinetext'></profile-text>
                          <p v-if="!editing" class="mt-2">
                            <strong style="font-size: 1.2rem">Ano: </strong>
                          <!-- <a href="#" 
                            > -->
                          <!-- @click.prevent="goToUnidade(un.slug)"> -->
                              <v-chip label
                              desable 
                              color='primary'
                              outline>
                                  {{projetoData.ano}}
                              </v-chip>
                          <!-- </a> -->
                          </p>
                          <v-autocomplete
                            v-if="editing"
                            label="Ano"
                            :items="ano"
                            item-text="name"
                            item-value="name"
                            v-model="projetoData.ano"
                            max-height="400"
                            hint="Escolha o ano"
                            persistent-hint
                            ></v-autocomplete>
                          <p v-if="!editing">
                            <strong style="font-size: 1.2rem">Programas: </strong>
                              <v-chip label
                              v-for="un 
                              in projetoData.programas"
                              :key='un.name'
                              desable 
                              color='amber'
                              outline>
                                  {{un}}
                              </v-chip>
                          </p>

                          <v-autocomplete
                            v-if="editing"
                            label="Programa(s)"
                            :items="programasData"
                            item-text="name"
                            item-value="slug"
                            v-model="projetoData.programas"
                            max-height="400"
                            multiple
                            hint="Escolha o(s) programa(s)"
                            persistent-hint
                            ></v-autocomplete>
                          <v-btn
                          v-if="projetoData.instruction && !editing"
                          small
                          class="mt-2"
                          color="primary"
                          @click="planoAula">Plano de atividades</v-btn>
                          <div style="height: 1rem"></div>
                        </v-flex> 
                        
                    </v-card-title>
                    <v-btn
                      v-if="this.$store.state.selectedRole.name === 'Admin' || 
                      this.$store.state.selectedRole.name === 'Mediador' || permissao "
                      absolute
                      dark
                      fab
                      bottom
                      right
                      color="blue"
                      @click="pressFloatingButton()"
                      >
                      <v-icon v-if='!editing'>mode_edit</v-icon>
                      <v-icon v-else>done</v-icon>
                    </v-btn>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>
          <v-flex xs12 class="" v-if="atividades.length > 0"> 
            <fade-transition :duration="600" >
              <v-expansion-panel style="width: 100%" class="mt-2" v-if="refresh">
                <v-expansion-panel-content v-if="showCard">
                  <div slot="header"> Atividades </div>
                  <v-card raised tile v-for="(atividade, index) in atividades" :key="index">
                    <v-layout row wrap xs12 class="pl-3">
                      <profile-text title="Nome : " v-model='atividade.title'
                        :last="true"></profile-text>  
                      <v-icon
                        v-if="!ativShow[index]"
                        size="25"
                        @click="show(index)"
                        style=" margin-top: 15px" 
                      >
                        keyboard_arrow_down
                      </v-icon>    
                      <v-icon
                        v-if="ativShow[index]"
                        size="25"
                        @click="show(index)"
                        style="margin-top: 15px" 
                      >
                        keyboard_arrow_up
                      </v-icon>          
                    </v-layout>
                    <div v-if="ativShow[index]">
                      <v-card-text> 
                      <profile-text title="Descrição : " v-model='atividade.description'
                        :last="true"
                        input-type='multilinetext'></profile-text>
                      <profile-text title="Objetivo : " v-model='atividade.objetivo'
                        :last="true"
                        input-type='multilinetext'></profile-text>                  
                      </v-card-text>
                      <show-criterio
                      style="width: 100%"
                      :criterios="atividade.habilidades"
                      :titulo="false"
                      :solicitacao="false"
                      :botaosaved="false"
                      :btnedit="false">
                      </show-criterio>
                      <v-btn color="primary"
                      @click.stop="editarAtividade(atividade, index)"
                      flat 
                      v-if="permissao "
                      >Editar atividade</v-btn>
                      <hr>
                    </div>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </fade-transition>
          </v-flex>          
          <v-flex xs12 class="" v-if="solicitacoes.length > 0">
          <fade-transition :duration="600" >
            <v-expansion-panel style="width: 100%" class="mt-2" v-if="refresh" >
              <v-expansion-panel-content v-if="showSol" >
                <div slot="header"> Solicitações de evidência </div>
                <v-card raised tile v-for="(tarefas, index) in solicitacoes" :key="tarefas.obrigatorias" >
                  <v-layout row wrap xs12 class="pl-3">
                    <profile-text title="Nome : " v-model='tarefas.title'
                      :last="true"></profile-text> 
                    <v-icon
                      v-if="!solShow[index]"
                      size="25"
                      @click="show2(index)"
                      style=" margin-top: 15px" 
                    >
                      keyboard_arrow_down
                    </v-icon>    
                    <v-icon
                      v-if="solShow[index]"
                      size="25"
                      @click="show2(index)"
                      style="margin-top: 15px" 
                    >
                      keyboard_arrow_up
                    </v-icon>          
                  </v-layout>
                  <div v-if="solShow[index]">
                    <v-card-text v-if="refresh">
                      <profile-text title="Descrição : " v-model='tarefas.description'
                      :last="true"
                      input-type='multilinetext'></profile-text>
                    </v-card-text>
                    <show-criterio
                    style="width: 100%"
                    :criterios="tarefas.habilidades"
                    :titulo="false"
                    :solicitacao="false"
                    :botaosaved="false"
                    :btnedit="false">
                    </show-criterio>
                    <v-btn color="primary"
                    flat 
                    @click.stop="editarSolicitacao(tarefas, index)"
                    v-if="permissao "
                    >Editar solicitação</v-btn>
                    <hr>
                 </div>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </fade-transition>
          </v-flex>
          <v-layout align-center justify-center row fill-height>
            <v-progress-circular indeterminate 
            align-center
            :size="50" 
            style="text-align: center"
            color="primary" 
            v-if="waiting"
            ></v-progress-circular>
          </v-layout>          

      <!-- dialog de deletar projeto-->
      <v-dialog v-model="dialogDel" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Deseja deletar?</v-card-title>
          <v-card-text>Gostaria excluir esse projeto padrão com suas solicitacoes ?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="dialogDel = false">Cancelar</v-btn>
            <v-btn color="green darken-1" flat @click.native="excluir()">Deletar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
      v-model="snackbar"
      bottom
      color="success">
      {{ text }}
        <v-btn flat color="black" @click.native="snackbar = false">Close</v-btn>
      </v-snackbar>

      <!-- dialog de deletar solicitacao -->
      <v-dialog v-model="delTaf" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Deseja deletar?</v-card-title>
          <v-card-text>Gostaria excluir essa solicitação ?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="delTaf = false">Cancelar</v-btn>
            <v-btn color="green darken-1" flat @click.native="excluirTaf()">Deletar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- dialog de deletar atividade -->
      <v-dialog v-model="delAtividade" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Deseja deletar?</v-card-title>
          <v-card-text>Gostaria excluir essa atividade ?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="delAtividade = false">Cancelar</v-btn>
            <v-btn color="green darken-1" flat @click.native="excluirAtividade()">Deletar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
      v-model="snackbar"
      bottom
      color="success">
      {{ text }}
        <v-btn flat color="black" @click.native="snackbar = false">Close</v-btn>
      </v-snackbar>


      <!-- Dialog do editar  atividade-->

      <v-dialog id="dialog" v-model="dialogAtividade" max-width="100%">
      <v-card>
        <v-card-title> 
          <h1>Editar Atividade</h1>

          <v-icon
            size="25"
            @click="delAtividade = true"
            style="position: absolute; top: 8px; right: 16px" 
          >
            delete
          </v-icon> 
        </v-card-title>
        <v-card-text>
          <v-text-field 
            label="Titulo da atividade" 
            ref="obs"
            hint="Exemplo: Aula 1"
            v-model="atividadeTitulo"></v-text-field>
          <v-text-field 
            label="Descrição da atividade" 
            hint="Descreva o que necessita para realização da atividade"
            v-model="atividadeDescricao"></v-text-field>
            <v-text-field 
            label="Objetivo da atividade" 
            hint="Descreva o objetivo da atividade"
            v-model="atividadeObjetivo"></v-text-field>
          </v-card-text>
          <v-card-text>
            <h2>Resumo das habilidades já selecionadas</h2>
            <v-data-table
              :headers="headers"
              :items="editHabil.habilidades"
              item-key="id"
              hide-actions
              class="elevation-1"
            >
              <template slot="headerCell" slot-scope="props">
                <v-tooltip bottom>
                    <span slot="activator">
                    {{ props.header.text }}
                    </span>
                    <span>
                    {{ props.header.text }}
                    </span>
                </v-tooltip>
              </template>
              <template slot="items" slot-scope="props">
                <td >{{ props.item.classificacao }}</td>
                <td >{{ props.item.grupo }}</td>
                <td >{{ props.item.subgrupo }}</td>
                <td >{{ props.item.name }}</td>
              </template>
            </v-data-table>
          </v-card-text>
        <v-card-actions>
          <input-criterios-aval 
            style="width: 100%"
            :criterios="criterios"
            :titulo="titulo"
            :clear="clear"
            :btnedit="btnedit"
            :editHabil="editHabil"
            @edit="editAtividade"
            @cancel="dialogAtividade = false"
          >
          </input-criterios-aval>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de nova atividade-->

      <v-dialog id="dialog" v-model="newAtividade" max-width="100%">
      <v-card>
        <v-card-title> 
          <h1>Nova Atividade</h1>

        </v-card-title>
        <v-card-text>
          <v-text-field 
            label="Titulo da atividade" 
            ref="obs"
            hint="Exemplo: Aula 1"
            v-model="atividadeTitulo"></v-text-field>
          <v-text-field 
            label="Descrição da atividade" 
            hint="Descreva o que necessita para realização da atividade"
            v-model="atividadeDescricao"></v-text-field>
            <v-text-field 
            label="Objetivo da atividade" 
            hint="Descreva o objetivo da atividade"
            v-model="atividadeObjetivo"></v-text-field>
          </v-card-text>
        <v-card-actions>
          <input-criterios-aval 
            style="width: 100%"
            :criterios="criterios"
            :titulo="titulo"
            :clear="clear"
            :btnedit="btnedit"
            :editHabil="editHabil"
            @saved="saveAtividade"
          >
          </input-criterios-aval>
        </v-card-actions>
      </v-card>
    </v-dialog>


      <!-- Dialog do editar Solicitação-->

      <v-dialog id="dialog" v-model="dialog" max-width="100%">
      <v-card>
        <v-card-title> 
          <h1>Editar Solicitação</h1>

          <v-icon
            size="25"
            @click="delTaf = true"
            style="position: absolute; top: 8px; right: 16px" 
          >
            delete
          </v-icon> 
        </v-card-title>
        <v-card-text>
          <v-text-field 
            label="Titulo da atividade" 
            ref="obs"
            hint="Exemplo: Aula 1"
            v-model="tarefatitulo"></v-text-field>
          <v-text-field 
            label="Descrição da atividade" 
            hint="Descreva o que necessita para realização da atividade"
            v-model="tarefadescricao"></v-text-field>
          </v-card-text>
        <v-card-actions>
          <input-criterios-aval 
            style="width: 100%"
            :criterios="criterios"
            :titulo="titulo"
            :clear="clear"
            :btnedit="btnedit"
            :editHabil="editHabil"
            @edit="editAtual"
          >
          </input-criterios-aval>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de nova Solicitação-->

      <v-dialog id="dialog" v-model="newSolicitacao" max-width="100%">
      <v-card>
        <v-card-title> 
          <h1>Nova Solicitação</h1>

        </v-card-title>
        <v-card-text>
          <v-text-field 
            label="Titulo da atividade" 
            ref="obs"
            hint="Exemplo: Aula 1"
            v-model="tarefatitulo"></v-text-field>
          <v-text-field 
            label="Descrição da atividade" 
            hint="Descreva o que necessita para realização da atividade"
            v-model="tarefadescricao"></v-text-field>
          </v-card-text>
        <v-card-actions>
          <input-criterios-aval 
            style="width: 100%"
            :criterios="criterios"
            :solicitacao="solicitacao"
            :titulo="titulo"
            :clear="clear"
            :btnedit="btnedit"
            :editHabil="editHabil"
            @saved="saveSolicitacao"
          >
          </input-criterios-aval>
        </v-card-actions>
      </v-card>
    </v-dialog>

        <v-speed-dial
          v-model="fab"
          style="position: fixed; bottom: 0; right: 0"
        >
        <v-btn
          slot="activator"
          v-model="fab"
          color="blue darken-2"
          dark
          fab
        >
          <v-icon>add</v-icon>
          <v-icon>close</v-icon>
        </v-btn>

        <v-tooltip left>
          <v-btn
            fab
            dark
            small
            color="indigo"
            slot="activator"
            @click.native="newSolicitacao = true"
          >
            <v-icon>add_alert</v-icon>
            
          </v-btn>
          <span>Adicionar Solicitação</span>
        </v-tooltip>
        <v-tooltip left v-if="$store.state.selectedRole.name !== 'Aluno'">  
          <v-btn
            fab
            dark
            small
            slot="activator"
            color="amber"
            @click.native="newAtividade = true"
          >
            <v-icon>note_add</v-icon>
            
          </v-btn>
          <span>Adicionar Atividade</span>
        </v-tooltip>
        
    </v-speed-dial>


  </v-layout>
</template>

<script>
import api from '@/api'
import ProfileText from '@/components/reusable/ProfileText.vue'
import Evidencia from '@/components/reusable/evidencia.vue'
import AvalDialogContent from '@/components/reusable/AvalDialogContent.vue'
import ChangeImage from '@/components/reusable/ChangeImage.vue'
import {FadeTransition} from 'vue2-transitions'
import InputCriteriosAval from '@/components/reusable/inputCriteriosAval.vue'
import ShowCriterio from '@/components/reusable/showCriterio.vue'
export default {
  components: {
    ProfileText,
    AvalDialogContent,
    Evidencia,
    ChangeImage,
    FadeTransition,
    InputCriteriosAval,
    ShowCriterio
  },
  data () {
    return {
      currentTab: 'Sobre',
      showImageUpload: false,
      imageChangeModal: false,
      projetoData: [],
      editing: false,
      ativShow: [false, false, false, false, false, false, false, false, false],
      solShow: [false, false, false, false, false, false, false, false, false],
      showSol: true,
      showCard: true,
      fab: false,
      delTaf: false,
      delAtividade: false,
      dialogAtividade: false,
      newAtividade: false,
      newSolicitacao: false,
      solicitacao: true,
      dialog: false,
      dialogDel: false,
      refresh: true,
      evid_avaliada: {},
      dialog_criterios: false,
      snackbar: false,
      clear: true,
      btnedit: false,
      text: 'Excluída com sucesso',
      tempData: {},
      atividadeTitulo: '',
      atividadeDescricao: '',
      atividadeObjetivo: '',
      tarefatitulo: '',
      titulo: true,
      ano: {},
      tarefadescricao: '',
      salvandoCriterio: [],
      editHabil: [],
      options: {},
      programasData: [],
      criterios: [],
      lista: [],
      solicitacoes: [],
      search: '',
      selected: [],
      waiting: true,
      listamediador: [],
      atividades: [],
      page: 1,
      headers: [
        {text: 'Classificação', value: 'classificacao'},
        {text: 'Grupo', value: 'grupo'},
        {text: 'Subgrupo', value: 'subgrupo'},
        {text: 'Habilidade ou Competência', value: 'name'}
      ]
    }
  },
  mounted () {
    var projectid = this.$route.params.id
    api.request('GET', 'modeloProjetos/' + projectid + '/').then(response => {
      this.projetoData = response.data
      // console.log(response.data)
      this.getStudents(this.projetoData.moderador)
      this.getMediador()
    })
    api.request('GET', 'modeloTarefas/?modelo_projetos__id=' + projectid).then(resp => {
      this.solicitacoes = resp.data
      // console.log(resp.data)
    })
    api.request('GET', 'modelo-atividades/?modelo_projetos__id=' + projectid).then(resp => {
      this.atividades = resp.data.sort((a, b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0))
      console.log('atividades', resp.data)
    })
    api.request('GET', 'criterioavaliacao/').then(response => {
      this.criterios = response.data
      console.log('criterios', this.criterios)
      this.waiting = false
    })
    api.request('GET', 'ano/').then(response => {
      response.data.sort((a, b) => (a.order_number > b.order_number) ? 1 : ((b.order_number > a.order_number) ? -1 : 0))
      this.ano = response.data
    })
    api.request('GET', 'programas/').then(response => {
      this.programasData = response.data
    })

    this.$watch('projetoData.moderador', function () {
      this.getStudents(this.projetoData.moderador)
    })
    this.$watch('evidencias', function () {
      // this.refreshUI()
    })
  },
  watch: {
    page (val, oldVal) {
      this.getEvidencia(val)
    }
  },
  computed: {
    safeImage () {
      if (
        this.projetoData.image === '' ||
        this.projetoData.image === undefined
      ) {
        return 'https://firebasestorage.googleapis.com/v0/b/mundomaker-staging.appspot.com/o/images%2Fdefault-user-image.png?alt=media'
      } else {
        return this.projetoData.image
      }
    },
    permissao () {
      return this.$store.state.user.is_superuser
    }
  },
  methods: {
    excluir () {
      api.request('DELETE', 'modeloProjetos/' + this.$route.params.id + '/').then(resp => {
        if (this.solicitacoes.length === 0) {
          if (this.atividades.length === 0) {
            this.$router.push('/padroes')
          }
        }
        if (this.solicitacoes.length !== 0) {
          for (let index = 0; index < this.solicitacoes.length; index++) {
            api.request('DELETE', 'modeloTarefas/' + this.solicitacoes[index].id + '/').then(response => {
              if (this.atividades.length === 0) {
                this.$router.push('/padroes')
              }
            })
          }
        }
        if (this.atividades.length !== 0) {
          for (let index = 0; index < this.atividades.length; index++) {
            api.request('DELETE', 'modelo-atividades/' + this.atividades[index].id + '/').then(response => {
              this.$router.push('/padroes')
            })
          }
        }
      })
    },
    getUserImage (username) {
      var userarray = this.projetoData.integrantes.filter(value => {
        return value.username === username
      })
      if (userarray[0]) {
        return userarray[0].profilePic
      } else {
        return ''
      }
    },
    imageError () {
      this.onerror = null
      this.$refs.logo.src = this.projetoData.image
    },
    getUser (username) {
      var userarray = this.projetoData.integrantes.filter(value => {
        return value.username === username
      })
      return userarray[0]
    },
    planoAula () {
      window.open(this.projetoData.instruction)
    },
    pressFloatingButton () {
      if (this.editing) {
        this.performSave()
      } else {
        this.editing = !this.editing
      }
    },
    performSave () {
      var projectid = this.$route.params.id
      let self = this
      delete self.projetoData.image
      delete self.projetoData.instruction
      api
        .request('PATCH', 'modeloProjetos/' + projectid + '/', self.projetoData)
        .then(function (response) {
          self.refreshUI()
          // console.log(response)
        })
      self.editing = false
    },
    imageProject (image) {
      var path = 'modeloProjetos/' + this.$route.params.id + '/'

      var name = 'images/padroes/padraoPic_' + this.$route.params.id + '.jpg&' + new Date().getTime()

      var upload = this.fbstorage.child(name).putString(image, 'data_url')

      upload.on('state_changed',
      snapshot => console.log(snapshot),
      error => console.log(error),
      url => {
        console.log(upload.snapshot)
        var payload = {
          image: name
        }
        api
        .request('PATCH', path, payload).then(resp => {
          // console.log(resp.data)
          this.imageChangeModal = false
          this.refreshUI()
        })
      })
    },
    getMediador () {
      api.request('GET', 'search-user?groups__name=Mediador').then(resp => {
        this.listamediador = resp.data
      })
    },
    show (i) {
      this.showCard = false
      if (this.ativShow[i] === false) {
        this.ativShow[i] = true
      } else {
        this.ativShow[i] = false
      }
      this.showCard = true
    },
    show2 (i) {
      this.showSol = false
      if (this.solShow[i] === false) {
        this.solShow[i] = true
      } else {
        this.solShow[i] = false
      }
      this.showSol = true
    },
    refreshUI () {
      this.refresh = false
      var projectid = this.$route.params.id
      api.request('GET', 'modeloProjetos/' + projectid + '/').then(response => {
        this.projetoData = response.data
        api.request('GET', 'modeloTarefas/?modelo_projetos__id=' + projectid).then(resp => {
          this.solicitacoes = resp.data
          api.request('GET', 'modelo-atividades/?modelo_projetos__id=' + projectid).then(resp => {
            this.atividades = resp.data.sort((a, b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0))

            this.refresh = true
          })
        })
      })
    },
    editarSolicitacao (value, index) {
      // console.log(value, index)
      this.editHabil = value
      this.tarefatitulo = value.title
      this.tarefadescricao = value.description
      this.ident = index
      // console.log(index)
      this.btnedit = true
      this.dialog = true
    },
    editarAtividade (value, index) {
      // console.log(value, index)
      this.editHabil = value
      this.atividadeTitulo = value.title
      this.atividadeDescricao = value.description
      this.atividadeObjetivo = value.objetivo
      this.ident = index
      this.btnedit = true
      this.dialogAtividade = true
    },
    excluirTaf () {
      api.request('DELETE', 'modeloTarefas/' + this.editHabil.id + '/').then(response => {
        this.delTaf = false
        this.dialog = false
        this.refreshUI()
      })
    },
    excluirAtividade () {
      api.request('DELETE', 'modelo-atividades/' + this.editHabil.id + '/').then(response => {
        this.delAtividade = false
        this.dialogAtividade = false
        this.refreshUI()
      })
    },
    editAtual (value) {
      // console.log(value)
      for (let index = 0; index < value.length; index++) {
        this.lista[index] = value[index].id
      }
      // console.log(this.lista)

      this.salvandoCriterio = {
        'title': this.tarefatitulo,
        'description': this.tarefadescricao,
        'evidencia_foco': true,
        'habilidades_pks': this.lista
      }
      api.request('PATCH', 'modeloTarefas/' + this.editHabil.id + '/', this.salvandoCriterio).then(response => {
        // console.log(response)
        this.tarefatitulo = ''
        this.tarefadescricao = ''
        this.tarefaData = ''
        this.editHabil = []
        this.lista = []

        this.refreshUI()
      })

      this.dialog = false
    },
    editAtividade (value) {
      // console.log(value)
      for (let index = 0; index < value.length; index++) {
        this.lista[index] = value[index].id
      }
      // console.log(this.lista)

      this.salvandoCriterio = {
        'title': this.atividadeTitulo,
        'description': this.atividadeDescricao,
        'objetivo': this.atividadeObjetivo,
        'habilidades_pks': this.lista
      }
      api.request('PATCH', 'modelo-atividades/' + this.editHabil.id + '/', this.salvandoCriterio).then(response => {
        // console.log(response)
        this.atividadeTitulo = ''
        this.atividadeDescricao = ''
        this.atividadeObjetivo = ''
        this.editHabil = []
        this.lista = []

        this.refreshUI()
      })

      this.dialogAtividade = false
    },

    saveAtividade (value) {
      // console.log(value)
      for (let index = 0; index < value.length; index++) {
        this.lista[index] = value[index].id
      }
      // console.log(this.lista)

      this.salvandoCriterio = {
        'title': this.atividadeTitulo,
        'description': this.atividadeDescricao,
        'objetivo': this.atividadeObjetivo,
        'habilidades_pks': this.lista,
        'modelo_projetos': this.$route.params.id
      }
      api.request('POST', 'modelo-atividades/', this.salvandoCriterio).then(response => {
        // console.log(response)
        this.atividadeTitulo = ''
        this.atividadeDescricao = ''
        this.atividadeObjetivo = ''
        this.editHabil = []
        this.lista = []

        this.refreshUI()
      })

      this.newAtividade = false
    },
    saveSolicitacao (value) {
      // console.log(value)
      for (let index = 0; index < value.length; index++) {
        this.lista[index] = value[index].id
      }
      // console.log(this.lista)

      this.salvandoCriterio = {
        'title': this.tarefatitulo,
        'description': this.tarefadescricao,
        'evidencia_foco': true,
        'habilidades_pks': this.lista,
        'modelo_projetos': this.$route.params.id
      }
      api.request('POST', 'modeloTarefas/', this.salvandoCriterio).then(response => {
        // console.log(response)
        this.tarefatitulo = ''
        this.tarefadescricao = ''
        this.tarefaData = ''
        this.editHabil = []
        this.lista = []

        this.refreshUI()
      })

      this.newSolicitacao = false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/Padroes/Detail.vue